// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__14Opg","productName":"Table_productName__2-PHY"};